export const STORE_PHONE = '(332) 333-6412'

export const GIFT_BOX_SKU = '990000007'

export const ADDTHIS_ID = 'ra-5f4ec39268f6acd2'

export const FREE_SHIPPING_AMOUNT = 49.00

export const EXTEND_SKU = ';xtd;'

export const BOPUS_SHIPPING_DESCRIPTION = 'Zgallerie (BOPS)'
export const FREE_SHIPPING_DESCRIPTION = 'Free Shipping'
export const STANDARD_SHIPPING_DESCRIPTION = 'Zgallerie (Standard)'
export const STANDARD_PLUS_SHIPPING_DESCRIPTION = 'Zgallerie (Standard Plus)'
export const STORE_MAIN_LOGO_URL = 'https://assets.onekingslane.com/m/2a3672007ee7fa59/original/OKL-logo-reg.png'
export const STORE_MINI_LOGO_URL = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASYAAAELBAMAAACG2DYBAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAeUExURUdwTCIeHyIeHyIeHyIeHyIeHyIeHyIeHyIeHyIeHyjV+KIAAAAJdFJOUwCD5RFkpsgpRe48O04AAA4vSURBVHja7V1Lm9NGFr22bEvZ2TwC3jXdBKKdMQHinXswSbwzBHrinQOBjHcKYUJ7pwES2rux2q/zb2chWa5SlSxZKsn65kutaDfdPl1177n3nKqSif4e3PjPzcJBegv8WjRMY2DZKhYkAwC6xcJUAYB6AedpUCxM2rh4a0dvAadgMU7GGPPCEVQfi8JhmmBZOExlwCoKlntvXjQa119Q9bB59+4GE9smAABW5ZD89O0zwPa/qrmQUNeBo7wg8KSjvTsDgJH/QsfDNCATq9wI+s7Ta5/f3yft/vuL0zNvpS4FTCc0zI+gHkAyjth0AwCscyWopoDIee3H07dXvNdm1IGTGyZ97L3t7Uaj0bjWu/jdX9dPz3ycS6rlSVAl721t/uXz6yY7d61SrgT1h5fuzNx9uj724bj/so18CeqDl+7fXrx/f/GpcfaSmaCvProUVdeAkzx58h9usg2FcH/9PVEVLmWNsaa8Qa2CmO48/+j3vbikJma5YvrGBOY8LSw+btLPdAlqmmu3ov3pUtCUxXTCajtgRm0gp+5Xu//Io6GlX0jAq7m+T1B2PpgeMhRUYyAt2RYTAFql/BTeFR+GXWUwrSlQ82wjv25F+24Do15hMA2CRD/QTKZfyHr85hWRgc7WkoAIxijPboVI/9LtULRthWPf3X15lbec0k9f8qQ5Chg9wJwmOXYrm7r7mCFNK9Bi3fr9PrUPIqd80lwE9CZsogPJqY5I4h4ZtFwT6gByqiaSOBF946mrPOXUdlQlTOBWnjoR5SinmFEJMsH5pt8cEVG+BOXnHssEj5gG2LEP5vdsSPPnFy/eMArBeW5t8u8AZsFQIkA3iChfOcW3Stz46maLLcYH8KONMd+RX/vIffcwfo926iop587raz8ICwX891AW1P37IY133nIqnt8xKxymaTHN36JtJlA1Nzm1ly1ULxomPdAUF2LkKadi18NbhYsnuqC/R7zx7uz4+HWxzj945sItqziQ/vIFYGH4vCT1gg472Da0IISusTsLBTm+UuEa47uFwFTj5UMhcq+D4k3UhMdUiJ5zGtB+9eLN0yFclh3xNJS4eQfOO6dSmMzz+WnmubFFCKixb3fWAnv+hxtt3+7UC1OINTe2b5PnVBVCqevXTeB2a8NVBVHqhifxvnA39YoByjthUytOGSYaupFdxYGP2+rMfHge1KExGeM1W/SW27U7HGlyVpjnQZUPi0k32QTzPKjJYTGVYUIwyfuHjaemM2U2Xb0ds/FBMRlY99lOycSlv1tkZ+dK3HnK/PJHFxef+cI7MFdBgvIUcUY8/m9vK+oHi4i0d9dfAsDiMdOgON9wjmEfi02HkFG9u7dtr4/fHG+/+GmbZ/MyFzcTOJvTitk0v/oYIWNj5zQx6HNrVIazCads+qcPCB3LG27qL1smNx9V3N105pn0mSXsGr+0iPpYVXjRVHGszeGILHbOtOZOTLjVqgB2mzfF9Ve+WMiiVXmAiHGrjzk1A9TY2vhQWYS4NkT0qGumE6KpVplP09yUQZpRSThV0Ed24cRH02gqnSaaBM+v3pOc1sjGdsOgJoE0JxoGwsmntCwOZbQDM2JIMHXJAB5LVy6HpUOXxIC66yJ/ziT9H8hw6bQABJs+BQvNsuU1Ss41D5X2JFP3KbhUln+ZxR9XGaZ/fe2Hi09PxuzfkH1dOf8yCOlriV8oPZmobFSj2HLRcvVBCJceApNjE3scWODSTJ3AkHGVSH74KKtpMl4H6Sk4/rlzLjOIJn04F5xlCSQK7WXUiyjtCl5RMxpSJezbt9VP019wrPCMApyrgTIiC3/lWuXuzn7uakRnrH73p2LCsXf1c46vLkPUg0WfVMc3MN85TZ6UDOWmV2SobXu1JoD67gi3vOkMpcu+0oOa+hUAi1ZlJxGMyLtiLl3ZLlVUVmDNbUdOwkurW+ksoivA8kw2VT+qPAflH+B17F1EAACzz38BS4vo3fXAdDk3GJM81fS8526wzcLDlx3eUad37OVA76wR0pyDenTRa5y9NIN5E0fYMcvzrnH28vj4+PXzzbHWJAc1H51f9BrXBTDYXoqOHrsONex1UFM7Pw2Fsr0A0Y4DaVeZjX9LXz89M2O825yakf/nzk1rtxUczzbUnsQBJLuQKIynn6N71DjdSmUIqMG0iObDeNdK7o3jQsJ699otY7hKWhyPrmLGhoT5bhaPJbljXCsx4s8SsNjZ9sar+DGulTT3gITlTi6IVzSir5U82AcSHP8JAJ4vzn0znjPRibpWoo/3w9TiMXXN/UVS5LWSP/aCFLx0i+503wiP7lb2nCbMA3qEM+hi2stR3crD/SBhHeDMo0oCGyCiWxnuiemExgGMJtPGxBy7u5XSnpC4O7cuIzX3N7r6i8c7vjvdF5NdCnJDZz/CJCIydka4uSckp1UDFuxPbS91K3qSQ3XfaVrQBDiaSBdTkV3S3BfTnPrAqsQ94sVUeuJS3xeS2z7NNAD4KUAOyexlw0pV6vxr5Q41AXTdSf5xY5UnE5KTUcge0b5UYLcBjNoAMNso9YQ7A5N5yqzb7KsMSgBWFVeIf0i15fxF4G/ZO+uAbgUALjUTmNEYC8tvUhNu6tQCaz5JimlGTcBpTRfWtkm1krLRKlWt8x8x4VAbQLfU3UJKasPXePo3kACTvq0wR65tt2f9FUQxJ0AfJsA0chlypAE4Ie1K6o2mIU8i/QSYjsjzxZpwbPfxQal25jVeWGgJIGFFTVdZdvA1S7lJHSUD3LXhUhJMruS8SmQc22yOJHUDS3xR6iTBtKAOcJv0wB+V+A5NjWfbZhJMDtXg2Fqzyx/ESHxuqMz9sGYmwQSr5Dymh1gTE+ApdubL3NpVEkFCV7NJN4Gnz5Tc6ilz+VFLhmlE/Ayl3EutcVwwSYZpTfSnhCHSNN/dVIwJwHn/XULXKay0LFndp24kVwdDLK+y+ljdSBzivHNgqMSUJpzslJUlYmszSTgt0/W9GWDitznKhcA05mhkohBTYgUccMqnRcCk89TWVIhpkYIKBuk0C5QfHTL4ZlAlja8UYVJJmaMUMT5I4/JkUu64vKuopKeWGn6qKg3xSlcFj3cUYrpL5XnieudkQ08DmiaV5jUmGJWGuJX8cVMVRiE8VMriBuBYSYN8UwQ0lYy5phoSn0ib+gz1QS1jTpOr8+qmWj6AWsYcAsCPSRcP/yL/4pWqRqWlp2kOHgL4qvEsBYCfZe5PKU2FSR/a1liyydhO5a2kFStLSdvln0JMSgfeY3yWT79MWNmEeXIs3zRKav3+Ngacm0ntgpV4O2PBPsAhaRt1/rmV2Oo5Eo20FVMTbEo3EjVQdV1agNP69qkaclt0GWzmF6W+ZpAgoBzxVO2SNUNSX+6pJaGCkliAq0jvkqcIqLnYMr/iRP5J/gG1Eie3y7HoAQLqSHBjnJZuIp+Acr4LabzbYQVY0bGHHQE1N0I6pUlYAU6riKMD6kSuIVqSB0v1FRnlkRbUwAixmfqhBVhRkIcHlF0JsXSaoQVYUZAb4dxYCdnWGAbJQbxDmVFAzeTN34mAaSAoxdTXWSeh3FiVUwGJsxK4EnSSVUCNpJiWVnClliKlpL5ap4cqNhGT87Ml/ICrCt4qsYAjjFanFYynOy/cR3cbUs9wqDLxQgJqQUT6ee+04X221vtWCPV7leStki2q3W7dOqYW8ywC/rKylU1AHcX8G+Yye62VTUDVYybqicQQUfCBKFJbM5yL2yL2gN5XcN2vut/OV0esbW+hlp/khzEWMTuJmRjgSP/kbEN6C3Ids12+S0TnQyiud9VL2SWM0S6LnXt7/Zm6HXQ/ZBeyBqAeM00ticpIH+J9WJKAsuI1NwvZkdP0j5QYYyAGlBMzI9ayxq+bOsSBlRhQi5i0P5BgmqsgJ0lAzWI2y7ZYmRTcbu8AsATnbR5PES5J6DrT+09uZo+E5FnHs2jXYrVU8fgGE8BasADW8SrRSHAclgoeMlWRy6ZVvP69K7SEKi5s17xQNWNjagcKMJezvyqA5BXUk2BArWK1BfPgvKl5yMXQ++Xl2PE0DfRzJcc/7jdX8pwiLcQ3jdcW1F2+srzUU/TpAhU/WM24mJqBoqihPlRkE7ij7K/CNC7LDIPScvzLtpVSMfp+LanFxSS482pXjnmDlhEXkxlMzv5ynGLbdUc9rfOezzxOq+L1opOFYSp8clKVaeun8foCXeDsskN9hU9OmjAgavH6J0OQgFVYTYUPLmTzWo+HqSS4JxV8byqLJu7SxoB3a2Is98JfzWOFH+dR4ircJJYLURN51VTSyEmU/4KX6FZ0CJ5sI0Dhp570OUycILGjS/BgC1NZNPFKLeDF16PTwpdMhsIPQTICwr8cR/KP1ZmWkSZgl1cko0gaz+ZpweUgIZnRtrsRp51RtCX1KvDCZeTcnmSCqRnMs3J0U1dWZzJFdB1ezS1FF+GJUtW004wYBV9ZRM5tPeu0s4Mz50RSWjcLTDVx02YYVVwMZIupI0ZPM+otq8h27fqi7J1GkWYb2ebdUGTISZQ67ys8RRAr7ThM0sRj9zCy+EjLqgRTJ6KDMuJJZSWVRYZpFOE9zbINJ3+zrhMh8aZKN313Y7qUYJIt3lDpDoY43kpio7P7lAC/35ABQbE5NJNhWuxuTDP5aANJvfO44CWwtPri4ng/8QZw7A/ZNHXuQfsXcOzhisV0m4Z4RYbI1G1vUvu4S7qZzfOehwBm1FxTbcHmVZ1qsImGl/K0G1AJXaJ+Nh8pYoyBWa9/u3fq6V73TXu9J+j1es2VvLI8753iWq/XdzLBxDy7zxJUg6TkTYCMCYqIqNLwhvf1aaPR6HkHQhqCFtYb7LhB/7fjf+lbqUxoU98ZAAAAAElFTkSuQmCC'

export const PARKY_CREDIT_CARD_TRANSACTION_METHOD = 'Credit Card'
export const PARKY_PAYPAL_TRANSACTION_METHOD = 'PayPal'
export const EXTEND_LOGO = 'https://cdn11.bigcommerce.com/s-whvhnri10h/product_images/uploaded_images/extend-logo.png'
export const BRAND = 'One Kings Lane'
export const PLP_Items_Per_Page = 60
export type FoterLink = {
  name: string
  href: string
  ariaLabel?: string
}
export type FoterSection = {
  heading: string
  links: FoterLink[]
}
export const FOOTER_SECTIONS: FoterSection[] = [
  {
    heading: 'Our Company',
    links: [{
      name: 'About Us',
      href: '/about-us',
    },
    {
      name: 'Careers',
      href: '/careers',
    },
    {
      name: 'Blog',
      href: 'https://blog.onekingslane.com/',
    }],
  },
  {
    heading: 'Customer Care',
    links: [
      {
        name: 'Returns',
        href: 'https://returns.narvar.com/okl/returns',
      },
      {
        name: 'Order Status',
        href: '/order-status',
      }, {
        name: 'FAQ',
        href: '/faq',
        ariaLabel: 'Frequently asked questions',
      },
      {
        name: 'Return Policy',
        href: '/faq/#returns-exchange',
      },
      {
        name: 'Shipping and Delivery',
        href: '/faq/#shipping-delivery',
        ariaLabel: 'Frequently asked questions',
      },
      {
        name: 'Request a Swatch',
        href: '/swatch-request',
      },
      {
        name: 'Contact Us',
        href: '/contact-us',
      },
    ],
  },
  {
    heading: 'Resources',
    links: [
      {
        name: 'Free Design Services',
        href: '/design-services',
      },
      {
        name: 'To the Trade',
        href: '/to-the-trade',
      },
      {
        name: 'Affiliates',
        href: '/affiliates-apply-now',
      },
      {
        name: 'Farrow & Ball',
        href: '/farrow-ball',
      },
      {
        name: 'Protection Plan',
        href: '/extend-faq',
      },
      {
        name: 'Citizens Pay™',
        href: '/citizens-pay-faq',
      },
    ],
  },
]

export const designSkus = [
  '77469310', '77496064', '77496065', '77496066', '77496067',
  '77496068', '77496069', '77496070', '77496203', '77534784',
  '77534785', '77534786', '77534787', '77534788', '77535257',
  '77535258', '77535259', '77542926', '77542927', '77542928',
  '77542929', '77542930', '77542931', '77542932', '77542933',
  '77542934', '77542935', '77542936', '77542937', '77542938',
  '77542939', '77542940', '77576646', '77576647', '77576648',
  '77576649', '77576650', '77576651',
]

export const storeOperationHours = [
  'Monday-Friday 9 am - 7 pm EST',
  'Weekends & Holidays Closed',
]
